import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=3fcae3d9&scoped=true"
import script from "./FilterSidebar.ts?vue&type=script&lang=ts&external"
export * from "./FilterSidebar.ts?vue&type=script&lang=ts&external"
import style0 from "./FilterSidebar.scss?vue&type=style&index=0&id=3fcae3d9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcae3d9",
  null
  
)

export default component.exports